// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__NhHqZ","range":"MonthRangeSwitch_range__3-w0E","disabled":"MonthRangeSwitch_disabled__3MKam"};